import { Button as MuiButton, IconButton, Tooltip } from "@mui/material";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { spacing } from "@mui/system";
import styled from "@emotion/styled";
import { NavbarNotificationsDropdown } from "components/atoms/navbar-notifications-dropdown";
import { NavbarLanguagesDropdown } from "components/atoms/navbar-languages-dropdown";
import { Info } from "react-feather";
import { NavbarUserDropdown } from "components/atoms/navbar-user-dropdown";
import { useLocation, useNavigate } from "react-router-dom";
import { User } from "core/types/user.types";

const Button = styled(MuiButton)(spacing);

interface Props {
  user?: User;
  onButtonClick: () => void;
  onSignOut: () => void;
}

const HeaderActions: FunctionComponent<Props> = ({
  user,
  onSignOut,
  onButtonClick,
}) => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <>
      {user && location.pathname !== "/my-profile" && (
        <Button
          style={{ marginRight: 4 }}
          variant="outlined"
          color="info"
          onClick={() => navigate("/my-profile")}
        >
          {(user.billingInfo ? user.billingInfo?.searchesCount : 0) +
            t("header.remaining")}
        </Button>
      )}
      {location.pathname !== "/" && (
        <Button
          style={{ marginRight: 4 }}
          variant="contained"
          color="primary"
          onClick={onButtonClick}
          disabled={user?.billingInfo?.searchesCount === 0}
        >
          {t("header.search")}
        </Button>
      )}
      <NavbarNotificationsDropdown />
      <NavbarLanguagesDropdown />
      <Tooltip title={t("header.help")}>
        <IconButton
          onClick={() =>
            window.open(
              "mailto:support@miareputation.com",
              "_blank",
              "noreferrer"
            )
          }
        >
          <Info color="#1D2C54" />
        </IconButton>
      </Tooltip>
      <NavbarUserDropdown onSignOut={onSignOut} />
    </>
  );
};

export default HeaderActions;
